<template>
	<div>
		<div class="dashboard-text">
			<img src="../../../assets/oa/approve-back.png" alt="" style="margin-right: 5px;" @click="closeBack()">
			<span>审批中心</span>
		</div>
		<div class="dashboard-content" v-if="!detailShow">
			<div style="display: flex;">
				<div class="tab-wrap">
					<div class="tab" :class="tabIndex == index ? 'tabClass' : ''"
						:style="index == 0 ? 'border-left:none' : ''" v-for="(item, index) in tabList" :key="index"
						@click="tabClick(index)">{{ item }}</div>
				</div>
				<div class="tab-hr"></div>
			</div>
			<el-form :inline="true" :model="condition" style="position:relative;padding: 40px 0 0 46px;">
				<el-form-item label="审批类型">
					<el-select v-model="condition.approval_process_type" placeholder="全部" clearable
						style="width: 203px; margin-left: 10px;" filterable>
						<el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item label="审批状态">
                    <el-select v-model="ruleForm.roleId" placeholder="请选择" style="width:203px;" clearable>
                        <el-option v-for="item in roleList" :key="item.id" :label="item.roleName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item> -->
				<!-- <el-form-item>
                    <el-input v-model="ruleForm.name" placeholder="请输入查询内容" clearable></el-input>
                </el-form-item>
                <el-form-item> -->
				<el-form-item>
					<el-button class="dashboard-button" @click="Find(tabIndex)">查询</el-button>
				</el-form-item>
			</el-form>
			<section>
				<el-table ref="multipleTable" :data="tableData" class="tableBox" style="width: 96%;margin:0 2%;"
					:header-cell-style="{
						'text-align': 'center',
						background: '#F0F0F0',
						color: '#000'
					}" :cell-style="{ 'text-align': 'center' }" @selection-change="handleSelectionChange">
					<el-table-column type="index" label="序号" width="50"></el-table-column>
					<el-table-column label="审批类型" prop="set_type"></el-table-column>
					<el-table-column label="审批名称" prop="set_name"></el-table-column>
					<el-table-column label="提出时间" prop="proposed_time"></el-table-column>
					<el-table-column label="状态">
						<template slot-scope="scope">
							<img src="../../../assets/oa/approve-orange-round.png" alt="" v-if="scope.row.state == 0">
							<img src="../../../assets/oa/approve-red-round.png" alt="" v-if="scope.row.state == 2">
							<img src="../../../assets/oa/approve-green-round.png" alt="" v-if="scope.row.state == 1">
							<!-- 待处理--待处理  已处理--已同意 已驳回  已发起--待审批 已同意  我收到的--待审批 已同意-->
						</template>
					</el-table-column>
					<el-table-column label="通过时间" prop="pass_time"></el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<div class="dashboard-delDisplay">
								<img src="../../../assets/oa/operate-approve.png" alt=""
									@click="clickBtn('APPROVE', scope.row)">
								<img src="../../../assets/oa/operate-detail.png" alt="" style="margin: 0 10px;"
									@click="clickBtn('DETAIL', scope.row)">
							</div>
						</template>
					</el-table-column>
				</el-table>
			</section>
			<section style="text-align:center;padding:20px 0">
				<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
					layout=" prev, pager, next, jumper" :total="total">
				</el-pagination>
			</section>
		</div>
		<div v-if="detailShow == '1'">
			<div class="dashboard-content" style="padding-bottom: 30px;position: relative;">
				<div class="detail-wrap">
					<span class="detail-title">{{ detailList.set_name }}</span>
					<img src="../../../assets/oa/approve-green-square.png" alt="" class="detail-img"
						v-if="detailList.reviewer_state == 1">
					<img src="../../../assets/oa/approve-orange-square.png" alt="" class="detail-img"
						v-if="detailList.reviewer_state == 0">
				</div>
				<div class="detail-time">{{ detailList.reviewer_date }}</div>
				<div class="detail-button" v-if="detailList.reviewer_state == 0">
					<el-button size="small" class="dashboard-button" @click="clickBtn('AGREE', '1')">同意</el-button>
					<el-button size="small" class="dashboard-buttonWhite" @click="clickBtn('REJECT', '2')">驳回</el-button>
				</div>
			</div>
			<div class="detail-title-gray">申请详情</div>
			<div class="dashboard-content" style="padding:30px;" v-if="detailList.form != null">
				<VFormReader class="form" :form-json="formJson" :form-data="formData" :option-data="optionData"
					ref="vFormRef">
				</VFormReader>
			</div>
			<!-- 保证金 -->
			<div class="dashboard-content" style="padding:30px;" v-if="detailList.set_type == '19'">
				<div style="display:flex;margin-top:20px">
					<div class="text">
						<span>组织架构：</span><span>{{ detailList.oaDetails.organizeName }}</span>
					</div>
					<div class="text">
						<span>项目名称：</span><span>{{ detailList.oaDetails.project_name }}</span>
					</div>
					<div class="text">
						<span>金额：</span><span>{{ detailList.oaDetails.money_amount }}</span>
					</div>
					<div class="text">
						<span>申请人：</span><span>{{ detailList.oaDetails.applicantName }}</span>
					</div>
				</div>
				<div style="display:flex;margin-top:20px">
					<div class="text">
						<span>审批总监：</span><span>{{ detailList.oaDetails.approval_director }}</span>
					</div>
					<div class="text">
						<span>预计付款时间：</span><span>{{ detailList.oaDetails.estimate_payment_time }}</span>
					</div>
					<div class="text">
						<span>付款时间：</span><span>{{ detailList.oaDetails.payment_time }}</span>
					</div>
					<div class="text">
						<span>未回款金额：</span><span>{{ detailList.oaDetails.uncollected_payment }}</span>
					</div>
				</div>
				<div style="display:flex;margin-top:20px">
					<div class="text">
						<span>备注：</span><span>{{ detailList.oaDetails.spare }}</span>
					</div>
					<div class="text">
						<span>最后操作时间：</span><span>{{ detailList.oaDetails.modified_time }}</span>
					</div>
				</div>
			</div>
			<!-- 履约金 -->
			<div class="dashboard-content" style="padding:30px;" v-if="detailList.set_type == '22'">
				<div style="display:flex;margin-top:20px">
					<div class="text">
						<span>组织架构：</span><span>{{ detailList.oaDetails.organizeName }}</span>
					</div>
					<div class="text">
						<span>项目名称：</span><span>{{ detailList.oaDetails.projectName }}</span>
					</div>
					<div class="text">
						<span>区域总管：</span><span>{{ detailList.oaDetails.areaManagerName }}</span>
					</div>
					<div class="text">
						<span>金额：</span><span>{{ detailList.oaDetails.money_amount }}</span>
					</div>
				</div>
				<div style="display:flex;margin-top:20px">
					<div class="text">
						<span>申请人：</span><span>{{ detailList.oaDetails.applicantName }}</span>
					</div>
					<div class="text">
						<span>预计付款时间：</span><span>{{ detailList.oaDetails.estimate_payment_time }}</span>
					</div>
					<div class="text">
						<span>付款时间：</span><span>{{ detailList.oaDetails.payment_time }}</span>
					</div>
					<div class="text">
						<span>未回款金额：</span><span>{{ detailList.oaDetails.uncollected_payment_money }}</span>
					</div>
				</div>
				<div style="display:flex;margin-top:20px">
					<div class="text">
						<span>是否撤场：</span><span>{{ detailList.oaDetails.spare }}</span>
					</div>
					<div class="text">
						<span>收据情况：</span><span>{{ detailList.oaDetails.is_receipt == '1' ? '有' : '无' }}</span>
					</div>
					<div class="text">
						<span>备注：</span><span>{{ detailList.oaDetails.spare }}</span>
					</div>
					<div class="text">
						<span>最后操作时间：</span><span>{{ detailList.oaDetails.modified_time }}</span>
					</div>
				</div>
			</div>
			<!-- 冲账 -->
			<div class="dashboard-content" style="padding:30px;" v-if="detailList.set_type == '20'">
				<div style="display:flex;margin-top:20px">
					<div class="text">
						<span>项目名称：</span><span>{{ detailList.oaDetails.projectName }}</span>
					</div>
					<div class="text">
						<span>金额：</span><span>{{ detailList.oaDetails.amount }}</span>
					</div>
				</div>
			</div>
			<!-- 转化履约金 -->
			<div class="dashboard-content" style="padding:30px;" v-if="detailList.set_type == '21'">
				<div style="display:flex;margin-top:20px">
					<div class="text">
						<span>项目名称：</span><span>{{ detailList.oaDetails.projectName }}</span>
					</div>
					<div class="text">
						<span>金额：</span><span>{{ detailList.oaDetails.amount }}</span>
					</div>
				</div>
			</div>
			<!-- 预算 -->
			<div class="dashboard-content" style="padding:30px;"
				v-if="detailList.set_type == '17' || detailList.set_type == '18'">
				<div style="display:flex;margin-top:20px">
					<el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" ref="multipleTable"
						:data="newdata" tooltip-effect="dark" style="width: 100%">
						<el-table-column label="序号">
							<template slot-scope="scope_1">
								{{ scope_1.$index + 1 }}
							</template>
						</el-table-column>
						<el-table-column prop="projectName" align="center" label="项目名称"></el-table-column>
						<el-table-column prop="annual" align="center" label="预算年度目标数据汇总">
							<el-table-column prop="annual" align="center" label="预算年度"></el-table-column>
							<el-table-column prop="annualTotalRevenue" align="center" label="年度总营收"></el-table-column>
							<el-table-column prop="annualTotalExpenditure" align="center" label="年度总支出"></el-table-column>
							<el-table-column prop="annualTotalProfit" align="center" label="年度税后总利润"></el-table-column>
							<el-table-column prop="annualTotalTax" align="center" label="年度税后"></el-table-column>
						</el-table-column>
						<el-table-column align="center" label="1月" prop="accumulate_1"></el-table-column>
						<el-table-column align="center" label="2月" prop="accumulate_2"></el-table-column>
						<el-table-column align="center" label="3月" prop="accumulate_3"></el-table-column>
						<el-table-column align="center" label="4月" prop="accumulate_4"></el-table-column>
						<el-table-column align="center" label="5月" prop="accumulate_5"></el-table-column>
						<el-table-column align="center" label="6月" prop="accumulate_6"></el-table-column>
						<el-table-column align="center" label="7月" prop="accumulate_7"></el-table-column>
						<el-table-column align="center" label="8月" prop="accumulate_8"></el-table-column>
						<el-table-column align="center" label="9月" prop="accumulate_9"></el-table-column>
						<el-table-column align="center" label="10月" prop="accumulate_10"></el-table-column>
						<el-table-column align="center" label="11月" prop="accumulate_11"></el-table-column>
						<el-table-column align="center" label="12月" prop="accumulate_12"></el-table-column>
						<el-table-column align="center" label="操作">
							<template slot-scope="scope">
								<img src="../../../assets/oa/operate-detail.png" alt="" style="margin: 0 10px;"
									@click="clickBtn('DETAILTwo',scope.row)">
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<el-dialog :title="title" :visible.sync="showDialog" :center="true" :width="width" class="modal">
			<div v-for="(item, index) in approveList.oaExamineDetails" :key="index">
				<div class="approve">
					<div class="approve-left">
						<img src="../../../assets/oa/flowPath-green.png" alt="" class="approve-img"
							v-if="item.reviewer_state == 1">
						<img src="../../../assets/oa/flowPath-red.png" alt="" class="approve-img"
							v-if="item.reviewer_state == 2">
						<img src="../../../assets/oa/flowPath-orange.png" alt="" class="approve-img"
							v-if="item.reviewer_state == 0">
						<!-- <img src="../../../assets/oa/flowPath-blue.png" alt="" class="approve-img" 
						v-if="item.reviewer_state != 0 || item.reviewer_state != 1 || item.reviewer_state != 2"> -->
					</div>
					<div class="position">
						<div class="position-left">
							<div>{{ item.staff_name }}</div>
							<div
								:class="item.reviewer_state == 0 ? 'orange' : item.reviewer_state == 1 ? 'green' : item.reviewer_state == 2 ? 'red' : 'blue'">
								<span v-if="item.reviewer_state == 1">已同意</span>
								<span v-if="item.reviewer_state == 2">已驳回</span>
								<span v-if="item.reviewer_state == 0">待审批</span>
								<!-- <span v-if="item.reviewer_state != 0 || item.reviewer_state != 1 || item.reviewer_state != 2">发起申请</span> -->
							</div>
							<div class="position-refuse" v-if="item.reviewer_state == 2">
								驳回原因：{{ item.reject_reason }}
							</div>
						</div>
						<div class="position-time" v-if="item.reviewer_state != 0">{{ item.reviewer_date }}</div>
					</div>
				</div>
				<div class="approve-hr" v-if="index != approveList.oaExamineDetails.length - 1"></div>
			</div>
		</el-dialog>
		<el-dialog :title="status == '1' ? '同意原因' : '驳回原因'" :visible.sync="ShowAgreeReject" width="30%"
			:before-close="handleClose">
			<el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.reject_reason">
			</el-input>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="SaveAgreeReject(status)"
					style="background-color: #006E4B; border-color: #006E4B;">确 定</el-button>
			</span>
		</el-dialog>

		<detailPage v-if="detailShow == '2'" :detailMonetyId="detailMonetyId" @closeBack2="closeBack2"></detailPage>
	</div>
</template>

<script>
import detailPage from './Budgeting.vue'
import VFormReader from './../../form-render/index.vue'
import axios from "axios";
// import { baseRequest } from '@/api/system'
export default {
	components: { VFormReader, detailPage },
	props: {
		stateText: Number,
		default: ''
	},
	data() {
		return {
			tabList: ['待处理', '已处理', '已发起', '我收到的'],
			tabIndex: -1,
			formJson: {},
			formData: {},
			optionData: {},
			condition: {
				page_num: 1,
				page_size: 10,
				approval_process_type: '',
				proposed_id: '',
			},
			form: {
				id: '',
				staff_ids: '',
				reviewer_state: '',
				reject_reason: '',
			},
			approveList: [],
			detailList: [],
			//类型下拉
			typeList: [{
				value: 1,
				label: "加班审批"
			},
			{
				value: 2,
				label: "请假审批"
			},
			{
				value: 3,
				label: "岗位支援审批"
			},
			{
				value: 4,
				label: "离职审批"
			},
			{
				value: 5,
				label: "代岗审批"
			},
			{
				value: 6,
				label: "外出审批"
			},
			{
				value: 7,
				label: "调薪审批"
			},
			{
				value: 8,
				label: "补卡审批"
			},
			{
				value: 9,
				label: "出差审批"
			},
			{
				value: 10,
				label: "处罚审批"
			},
			{
				value: 11,
				label: "入职审批"
			},
			{
				value: 12,
				label: "调岗审批"
			},
			{
				value: 13,
				label: "转正审批"
			},
			{
				value: 14,
				label: "工资明细审批"
			},
			{
				value: 15,
				label: "工资占比审批"
			},
			{
				value: 16,
				label: "工资汇总审批"
			},
			{
				value: 17,
				label: "预算编制审批"
			},
			{
				value: 18,
				label: "预算编制月度审批"
			},
			{
				value: 19,
				label: "保证金审批"
			},
			{
				value: 20,
				label: "冲账审批"
			},
			{
				value: 21,
				label: "转化履约金审批"
			},
			{
				value: 22,
				label: "履约金审批"
			},
			{
				value: 23,
				label: "预算执行"
			}
			],

			ruleForm: {
				name: '',
			},
			total: 0,
			tableData: [],
			showDialog: false,
			ShowAgreeReject: false,
			status: '',
			width: "",
			title: "",
			selectId: [],
			roleList: [],
			detailShow: '',
			detailState: '3', //1已同意3待审批

			newdata: [],

			detailMonetyId: '',
		}
	},
	mounted() {
		if (this.stateText == 0) this.tabIndex = 0
		if (this.stateText == 1) this.tabIndex = 2
		if (this.stateText == 2) this.tabIndex = 1
		if (this.stateText == 3) this.tabIndex = 3
		this.Find(this.tabIndex)
	},
	methods: {
		tabClick(index) {
			this.tabIndex = index;
			this.Find(index)
		},
		closeBack() {
			if (this.detailShow == '1') {
				this.detailShow = ''
			} else {
				this.$emit('closeBack')
			}
		},
		closeBack2(){
			if (this.detailShow == '2') {
				this.detailShow = '1'
			}
		},
		queryDict() {
			baseRequest('/sysRole/sysRole/findList', {}).then(res => {
				console.log(res.data);
				this.roleList = res.data
			})
		},
		async Find(e) {
			this.condition.proposed_id = this.$globals.user.staff_id;
			if (e == 0) {
				var data = await this.$globals.AxiosPost('OaManageApproval/getListThree', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			} else if (e == 1) {
				var data = await this.$globals.AxiosPost('OaManageApproval/getListFour', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			} else if (e == 2) {
				var data = await this.$globals.AxiosPost('OaManageApproval/getListOne', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			} else {
				var data = await this.$globals.AxiosPost('OaManageApproval/getListTwo', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			}
		},
		clickBtn(type, item) {
			console.log(item, '11111');
			let that = this;
			const TYPE_METHODS = {
				async ["APPROVE"]() {
					that.width = "500px";
					that.title = "查看审批流程";
					var data = await that.$globals.AxiosGet('OaManageApproval/getOaExamineDetails?info=' + item
						.id);
					if (data === '-2000') {
						that.$message.error('服务器未响应！请稍后重试');
					} else {
						var code = data.code;
						var data = data.data;
						if (code === '200') {
							that.showDialog = true;
							that.approveList = data;
						} else {
							that.$message.warning('请求失败！请稍后重试');
						}
					}

				},
				async ["DETAIL"]() {
					var staff_id = '&staff_id=' + that.$globals.user.staff_id;
					var data = await that.$globals.AxiosGet('OaManageApproval/findDateById?info=' + item.id + staff_id);
					if (data === '-2000') {
						that.$message.error('服务器未响应！请稍后重试');
					} else {
						var code = data.code;
						var data = data.data;
						var form = data.form;
						that.newdata = data.oaDetails
						if (code === '200') {
							that.detailShow = '1';
							that.detailList = data;
							that.$nextTick(() => {
								that.$refs.vFormRef.setFormJson(form)
								// that.optionData = data.data
								let newFormData = null
								newFormData = data.data
								console.log(newFormData);
								that.$refs.vFormRef.setFormData(newFormData)
								console.log(that.$refs.vFormRef);
								that.$refs.vFormRef.setReadMode(true)
							})
							that.form.id = data.id;
						} else {
							that.$message.warning('请求失败！请稍后重试');
						}
					}
				},
				async ["DETAILTwo"]() {
					that.detailMonetyId = item.id
					that.detailShow = '2'
				},
				async ["AGREE"]() {
					that.status = item;
					that.ShowAgreeReject = true;
				},
				async ["REJECT"]() {
					that.status = item;
					that.ShowAgreeReject = true;
				}
			};
			TYPE_METHODS[type]();
		},
		async SaveAgreeReject(e) {
			this.form.staff_ids = this.$globals.user.staff_id;
			this.form.reviewer_state = e;
			var data = await this.$globals.AxiosPost('OaManageApproval/modify', this.form);
			if (data === '-2000') {
				this.$message.error('服务器未响应！请稍后重试');
			} else {
				var code = data.code;
				var data = data.data;
				if (code === '200') {
					this.$message.success(data);
					this.form = {};
					this.ShowAgreeReject = false;
					this.closeBack()
				} else {
					this.$message.warning(data);
				}
			}
		},
		handleSelectionChange(val) {
			this.selectId = [];
			val.map((item) => {
				this.selectId.push(item.id);
			});
		},
		handleCurrentChange(val) {
			this.condition.page_num = val;
			this.Find();
		},
	}
}
</script>

<style>
.el-form-item__label {
	font-size: 16px;
}

.modal .el-dialog__title {
	font-size: 17px;
	font-weight: 600;
}

.form .el-input__inner {
	border: none !important;
	margin-top: 2px;
}

.form .el-upload--picture-card {
	display: none;
}

.form .field-wrapper {
	margin-left: 10px;
}
</style>
<style scoped>
.detail-button {
	position: absolute;
	top: 30px;
	right: 20px;
}

.text {
	width: 25%
}

.applay-wrap {
	margin: 0 40px 22px 60px;
	display: flex;
	justify-content: space-between;
}

.applay {
	display: flex;
	font-size: 14px;
}

.left {
	width: 60%;
}

.right {
	width: 32%;
}

.applay-title {
	color: #C1C1C1;
}

.applay-text {}

.detail-wrap {
	display: flex;
	align-items: center;
	padding: 36px 0 0 24px;
}

.detail-title {
	font-size: 18px;
	font-weight: 600;
}

.detail-img {
	margin: 0 10px;
}

.detail-time {
	font-size: 13px;
	margin-left: 26px;
	color: #C1C1C1;
}

.detail-title-gray {
	line-height: 50px;
	margin: 0 40px;
	padding-left: 26px;
	font-weight: 600;
	font-size: 18px;
}

.approve {
	display: flex;
}

.approve-left {
	width: 16%;
	text-align: right;
}

.approve-img {
	width: 50px;
	height: 50px;
}

.approve-hr {
	border-right: 2px solid #C7DCF0;
	height: 40px;
	width: 1px;
	margin-left: 10%;
	margin-top: -5px;
}

.position {
	display: flex;
	justify-content: space-between;
	width: 78%;
	margin-left: 5px;
}

.position-left {
	display: flex;
	flex-direction: column;
	justify-content: center;
	font-size: 16px;
	font-weight: 600;
	line-height: 24px;
}

.position-refuse {
	width: 205%;
	line-height: 30px;
	font-size: 12px;
	font-weight: 400;
	padding-left: 10px;
	background: #F9F9F9;
}

.position-text {
	font-size: 13px;
	margin: 0 10px;
	color: #C1C1C1;
}

.blue {
	color: #3295FA;
}

.green {
	color: #14BB83;
}

.orange {
	color: #FD892C;
}

.red {
	color: #F05745;
}

.position-time {
	font-size: 13px;
	color: #C1C1C1;
	line-height: 26px;
}

.tab-wrap {
	display: flex;
}

.tab {
	width: 110px;
	line-height: 38px;
	text-align: center;
	font-size: 14px;
	border-bottom: 1px solid #F7F6F9;
}

.tabClass {
	border-top: 2px solid #006E4B;
	border-left: 1px solid #F7F6F9;
	border-right: 1px solid #F7F6F9;
	border-bottom: 1px solid transparent;
}

.tab-hr {
	border-bottom: 1px solid #F7F6F9;
	width: calc(100vw - 440px);
}

.dashboard-text {
	font-size: 20px;
	margin: 36px 0 10px 40px;
	font-weight: 600;
	display: flex;
	align-items: center;
}

.dashboard-content {
	background: #fff;
	font-size: 16px;
	border: 1px solid transparent;
	margin: 0 40px;
}

.dashboard-button {
	width: 85px;
	background: #006E4B;
	color: #FFFFFF;
	border: 1px solid #006E4B;
}

.dashboard-buttonWhite {
	width: 85px;
	color: #006E4B;
	border: 1px solid #006E4B;
}
</style>



// WEBPACK FOOTER //
// approveCenter.vue?fa04e4ee